import { SupportComponent } from './landing-pages/support/support.component';
import { ClosedMonthComponent } from './Data/Accountant/company-documents/closed-month/closed-month.component';
import { OrderComponent } from './Data/order/order.component';
import { DocumentsComponent } from './Data/company/documents/documents.component';
import { UsersComponent } from './Data/users/users.component';
import { InvoicesTypesComponent } from './Data/invoices-types/invoices-types.component';
import { ProductsComponent } from './Data/products/products.component';
import { ProductFormComponent } from './Data/products/product-form/product-form.component';
import { MerchantProductCategoriesComponent } from './Data/merchant-product-categories/merchant-product-categories.component';
import { CustomersComponent } from './Data/customers/customers.component';
import { CustomerBalancesComponent } from './Data/customer-balances/customer-balances.component';
import { CustomerAccountEntriesComponent } from './Data/customer-account-entries/customer-account-entries.component';
import { CustomerAccountCardComponent } from './Data/customer-account-card/customer-account-card.component';
import { ChecksReportComponent } from './Data/checks-report/checks-report.component';
import { PlansInfoComponent } from './Data/plans-info/plans-info.component';
import { AdminMerchantSubscriptionsComponent } from './Data/plans-info/admin-merchant-subscriptions/admin-merchant-subscriptions.component';
import { AdminCustomPaymentsComponent } from './Data/plans-info/admin-custom-payments/admin-custom-payments.component';
import { ViewMerchantComponent } from './Data/merchant/view-merchant/view-merchant.component';
import { FirstPageComponent } from './components/simple-page/first-page/first-page.component';
import { HttpConfigInterceptor } from './interciptor/jwt.interceptor';
import { AboutComponent } from './landing-pages/about/about.component';
import { HomeheaderComponent } from './landing-pages/homeheader/homeheader.component';
import { HomeComponent } from './landing-pages/home/home.component';
import { CampaignLandingComponent } from './landing-pages/campaign-landing/campaign-landing.component';
import { ThiCampaignHeaderComponent } from './landing-pages/thi/campaign/thi-campaign-header.component';
import { ThiCampaignMainComponent } from './landing-pages/thi/campaign/thi-campaign-main.component';
import { ThiPublicPricingComponent } from './landing-pages/thi/campaign/thi-public-pricing.component';
import { ThiLandingHeaderComponent } from './landing-pages/thi/thi-landing-header.component';
import { ThiLandingFooterComponent } from './landing-pages/thi/thi-landing-footer.component';
import { ThiLandingMainComponent } from './landing-pages/thi/thi-landing-main.component';
import { ThiArticlesComponent } from './landing-pages/thi-articles/thi-articles.component';
import { ThiArticleDetailComponent } from './landing-pages/thi-articles/thi-article-detail.component';
import { ThiPageShellComponent } from './landing-pages/thi/thi-page-shell.component';
import { NavigathionComponent } from './landing-pages/navigathion/navigathion.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, isDevMode, APP_INITIALIZER } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MultiTranslateHttpLoader } from './services/multi-translate-loader';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
// CKEditor
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

// PrimeNG Modules
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { CardModule } from 'primeng/card';

import { MerchantDocumentsComponent } from './Data/merchant/merchant-documents/merchant-documents.component';

// // for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// // for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// // for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';

import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';
import { AuthorityConnectionBannerComponent } from './components/authority-connection-banner.component';
import { AppleAppBannerComponent } from './components/apple-app-banner.component';
import { AndroidAppBannerComponent } from './components/android-app-banner.component';
import { AuthorityToastComponent } from './components/authority-toast.component';
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { NgSelectModule } from '@ng-select/ng-select';

import { OverlayModule } from '@angular/cdk/overlay';
import { TermsAndConditionsComponent } from './landing-pages/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './landing-pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './landing-pages/terms-of-service/terms-of-service.component';
import { RegisterComponent } from './Auth/register/register.component';
import { LoginComponent } from './Auth/login/login.component';
import { AutoLoginComponent } from './Auth/auto-login/auto-login.component';
import { ForgotPasswordComponent } from './Auth/forgot-password/forgot-password.component';
import { SubPlansComponent } from './landing-pages/sub-plans/sub-plans.component';
import { Error404Component } from './Auth/error404/error404.component';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { OtpComponent } from './Auth/otp/otp.component';
import { ResendotpComponent } from './Auth/resendotp/resendotp.component';
import { TrustedDevicesComponent } from './Auth/trusted-devices/trusted-devices.component';
import { PlansComponent } from './Auth/plans/plans.component';
import { CompanyComponent } from './Data/company/company.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NgxPaginationModule } from 'ngx-pagination';
import { PlaneDetailsComponent } from './components/dashboard/plane-details/plane-details.component';
import { MerchantComponent } from './Data/merchant/merchant.component';
import { UpdateMerchantComponent } from './Data/merchant/update-merchant/update-merchant.component';
import { ViewCompanyComponent } from './Data/company/view-company/view-company.component';
import { UpdateCompanyComponent } from './Data/company/update-company/update-company.component';
import { VatListComponent } from './Data/vat-list/vat-list.component';
import { AdminExpenseQuotaComponent } from './Data/admin-expense-quota/admin-expense-quota.component';
import { AdminPushNotificationsComponent } from './Data/admin-push-notifications/admin-push-notifications.component';
import { AdminOutletComponent } from './components/admin/admin-outlet.component';
import { CategoriesComponent } from './Data/categories/categories.component';
import { MeasurementUnitsComponent } from './Data/measurement-units/measurement-units.component';
import { UsersPrivilegesComponent } from './Data/users-privileges/users-privileges.component';
import { ReceiptsComponent } from './Data/receipts/receipts.component';
import { VatListDetailsComponent } from './Data/vat-list/vat-list-details/vat-list-details.component';
import { BanksComponent } from './Data/banks/banks.component';
import { BanksBranchesComponent } from './Data/banks/banks-branches/banks-branches.component';
import { PaymentMethodComponent } from './Data/payment-method/payment-method.component';
import { InvoicesComponent } from './Data/invoices/invoices.component';
import { AddInvoiceComponent, NumberFormatPipe } from './Data/invoices/add-invoice/add-invoice.component';
import {AddFinaicalRequestComponent} from './Data/finaical-request/add-finaical-request/add-finaical-request.component';
import { UpdateInvoiceComponent } from './Data/invoices/update-invoice/update-invoice.component';
import { ExportPdfComponent } from './Data/invoices/export-pdf/export-pdf.component';
import { AddReceiptsComponent } from './Data/receipts/add-receipts/add-receipts.component';
import { ExportReceiptPdfComponent } from './Data/receipts/export-receipt-pdf/export-receipt-pdf.component';
import { PermanentFileComponent } from './Data/permanent-file/permanent-file.component';
import { AppInfoComponent } from './Data/app-info/app-info.component';
import { FinaicalRequestComponent } from './Data/finaical-request/finaical-request.component';
import { UpdateFinaicalRequestComponent } from './Data/finaical-request/update-finaical-request/update-finaical-request.component';
import { TermsComponent } from './Data/terms/terms.component';
import { InvoiceAndReceiptComponent } from './Data/invoice-and-receipt/invoice-and-receipt.component';
import { AddInvoiceWithReceiptComponent } from './Data/invoice-and-receipt/add-invoice-with-receipt/add-invoice-with-receipt.component';
import { UpdateInvoiceWithReceiptComponent } from './Data/invoice-and-receipt/update-invoice-with-receipt/update-invoice-with-receipt.component';
import { ExportInvoiceWithReceiptPdfComponent } from './Data/invoice-and-receipt/export-invoice-with-receipt-pdf/export-invoice-with-receipt-pdf.component';
import { ExportFinaicalRequestPdfComponent } from './Data/finaical-request/export-finaical-request-pdf/export-finaical-request-pdf.component';
import { AccountingOfficesComponent } from './Data/accounting-offices/accounting-offices.component';
import { AccountingOfficesCompaniesComponent } from './Data/accounting-offices/accounting-offices-companies/accounting-offices-companies.component';
import { OfficeComponent } from './Data/Accountant/office/office.component';
import { OfficeUsersComponent } from './Data/Accountant/office-users/office-users.component';
import { OfficeUsersPrivilegesComponent } from './Data/Accountant/office-users-privileges/office-users-privileges.component';
import { OfficeCompaniesComponent } from './Data/Accountant/office-companies/office-companies.component';
import { AccountantUserCompaniesComponent } from './Data/Accountant/accountant-user-companies/accountant-user-companies.component';
import { AccountantsComponent } from './Data/accountants/accountants.component';
import { CompanyDocumentsComponent } from './Data/Accountant/company-documents/company-documents.component';
import { DocumentPdfComponent } from './Data/Accountant/document-pdf/document-pdf.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ExportReportsComponent } from './Data/Accountant/export-reports/export-reports.component';
import { AgGridModule } from 'ag-grid-angular';
import { UploadPermanentFileComponent } from './Data/upload-permanent-file/upload-permanent-file.component';
import { ReverceInvoiceComponent } from './Data/reverce-invoice/reverce-invoice.component';
import { UpdateReverceInvoiceComponent } from './Data/reverce-invoice/update-reverce-invoice/update-reverce-invoice.component';
import { ExportReverceInvoicePdfComponent } from './Data/reverce-invoice/export-reverce-invoice-pdf/export-reverce-invoice-pdf.component';
import { AddReverceInvoiceComponent } from './Data/reverce-invoice/add-reverce-invoice/add-reverce-invoice.component';
import { MoreInfoCompanyComponent } from './Data/company/more-info-company/more-info-company.component';
import { UploadAllocationNumberComponent } from './Data/upload-allocation-number/uploadAllocationNumber.component';
import { AllUsersOfficeComponent } from './Data/accounting-offices/all-users-office/all-users-office.component';
import { AllMerchantUsersComponent } from './Data/merchant/all-merchant-users/all-merchant-users.component';
import { PasswordModule } from 'primeng/password';
import { HistoryComponent } from './Data/upload-permanent-file/history/history.component';
import { CompanyEmployeeComponent } from './Data/Accountant/office-companies/company-employee/company-employee.component';
import { HistoryDetailsComponent } from './Data/upload-permanent-file/history/history-details/history-details.component';
import { CalendarModule } from 'primeng/calendar';
import { DataTableModule } from '@bhplugin/ng-datatable';
import { MissionComponent } from './Data/Mission/Mission.component';
import { AddMissionComponent } from './Data/Mission/add-mission/add-mission.component';
import { UpdateMissionComponent } from './Data/Mission/update-mission/update-mission.component';
import { AddOrderComponent } from './Data/order/add-order/add-order.component';
import { UpdateOrderComponent } from './Data/order/update-order/update-order.component';
import { OfferPriceComponent } from './Data/offer-price/offer-price.component';
import { AddOfferPriceComponent } from './Data/offer-price/add-offer-price/add-offer-price.component';
import { UpdateOfferPriceComponent } from './Data/offer-price/update-offer-price/update-offer-price.component';
import { SkeletonModule } from 'primeng/skeleton';
import { SequanseComponent } from './Data/company/sequanse/sequanse.component';
import { OrderListModule } from 'primeng/orderlist';
import { DropdownModule } from 'primeng/dropdown';
import { AlldocumentsModule } from './components/alldocuments/alldocuments.module';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { DashboardModule } from './components/dashboard/dashboard.module';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { UpdateReceiptComponent } from './Data/receipts/update-receipt/update-receipt.component';
import { NumberFormatDirective } from './directives/number-format.directive';
import { MerchantModule } from './Data/merchant/merchant.module';
import { ReversereceiptComponent } from './Data/reverce-invoice/reversereceipt/reversereceipt.component';
import { DocumentModule } from './components/document/document.module';
import { InvoicesV2ListComponent } from './Data/invoices-v2/invoices-v2-list/invoices-v2-list.component';
import { InvoicesV2FormComponent } from './Data/invoices-v2/invoices-v2-form/invoices-v2-form.component';
import { InvoicesV2ProcedurePanelComponent } from './Data/invoices-v2/invoices-v2-procedure-panel/invoices-v2-procedure-panel.component';
import { HearingRequestDialogModule } from './components/shared/hearing-request-dialog/hearing-request-dialog.module';
import { InvoicesV2ViewComponent } from './Data/invoices-v2/invoices-v2-view/invoices-v2-view.component';
import { AiVoiceInvoiceComponent } from './Data/ai-voice-invoice/ai-voice-invoice.component';
import { AccountantWelcomeModalComponent } from './components/accountant-welcome-modal/accountant-welcome-modal.component';
import { ExpensePlansComponent } from './Data/expense-plans/expense-plans.component';
import { AdminAppVersionComponent } from './Data/admin-app-version/admin-app-version.component';
// import { CustomTranslateLoader } from './services/custom-translate-loader'; TODO: enable it after deploy to production
// import { TranslationAdminComponent } from './components/admin/translation-admin.component';  TODO: enable it after deploy to production
// TODO: enable it after deploy to production
// export function HttpLoaderFactory(http: HttpClient) {
//   return new CustomTranslateLoader(http);
// }
export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: 'assets/i18n/', suffix: '.json' },
    { prefix: 'assets/i18n/invoices-v2/', suffix: '.json' },
  ]);
}

@NgModule({
	declarations: [
		AppComponent,
		NumberFormatPipe,
		NumberFormatDirective,

		HomeComponent,
		CampaignLandingComponent,
		ThiCampaignHeaderComponent,
		ThiCampaignMainComponent,
		ThiPublicPricingComponent,
		ThiLandingHeaderComponent,
		ThiLandingFooterComponent,
		ThiLandingMainComponent,
		ThiArticlesComponent,
		ThiArticleDetailComponent,
		ThiPageShellComponent,
		HomeheaderComponent,
		AboutComponent,
		SupportComponent,
		SubPlansComponent,
		NavigathionComponent,
		TermsAndConditionsComponent,
		PrivacyPolicyComponent,
		TermsOfServiceComponent,
		RegisterComponent,
		LoginComponent,
		AutoLoginComponent,
		OtpComponent,
		ResendotpComponent,
		TrustedDevicesComponent,
		ForgotPasswordComponent,
		Error404Component,
		PlansComponent,
		InvoiceAndReceiptComponent,
		AddInvoiceWithReceiptComponent,
		UpdateInvoiceWithReceiptComponent,
		FirstPageComponent,
		PlaneDetailsComponent,
		ViewMerchantComponent,
		UpdateMerchantComponent,
		CompanyComponent,
		ViewCompanyComponent,
		UpdateCompanyComponent,
		VatListComponent,
		AdminExpenseQuotaComponent,
		AdminPushNotificationsComponent,
		AdminOutletComponent,
		AdminAppVersionComponent,
		CategoriesComponent,
		PlansInfoComponent,
		AdminMerchantSubscriptionsComponent,
		AdminCustomPaymentsComponent,
		ExpensePlansComponent,
		CustomersComponent,
		CustomerBalancesComponent,
		CustomerAccountCardComponent,
		CustomerAccountEntriesComponent,
		ChecksReportComponent,
		ProductsComponent,
		ProductFormComponent,
		MerchantProductCategoriesComponent,
		MeasurementUnitsComponent,
		UsersPrivilegesComponent,
		InvoicesTypesComponent,
		ReceiptsComponent,
		AddReceiptsComponent,
		UsersComponent,
		VatListDetailsComponent,
		BanksComponent,
		BanksBranchesComponent,
		PaymentMethodComponent,
		InvoicesComponent,
		AddInvoiceComponent,
		AddFinaicalRequestComponent,
		UpdateInvoiceComponent,
		ExportPdfComponent,
		ExportReceiptPdfComponent,
		PermanentFileComponent,
		AppInfoComponent,
		FinaicalRequestComponent,
		UpdateFinaicalRequestComponent,
		TermsComponent,
		ExportInvoiceWithReceiptPdfComponent,
		ExportFinaicalRequestPdfComponent,
		AccountingOfficesComponent,
		AccountingOfficesCompaniesComponent,
		OfficeComponent,
		OfficeUsersComponent,
		OfficeUsersPrivilegesComponent,
		OfficeCompaniesComponent,
		AccountantUserCompaniesComponent,
		AccountantsComponent,
		CompanyDocumentsComponent,
		DocumentPdfComponent,
		ExportReportsComponent,
		UploadPermanentFileComponent,
		ReverceInvoiceComponent,
		UpdateReverceInvoiceComponent,
		ExportReverceInvoicePdfComponent,
		AddReverceInvoiceComponent,
		MoreInfoCompanyComponent,
		UploadAllocationNumberComponent,
		DocumentsComponent,
		AllUsersOfficeComponent,
		AllMerchantUsersComponent,
		HistoryComponent,
		CompanyEmployeeComponent,
		HistoryDetailsComponent,
		MissionComponent,
		AddMissionComponent,
		UpdateMissionComponent,
		HomeComponent,
		OrderComponent,
		AddOrderComponent,
		UpdateOrderComponent,
		OfferPriceComponent,
		AddOfferPriceComponent,
		UpdateOfferPriceComponent,
		ClosedMonthComponent,
		SequanseComponent,
		MerchantDocumentsComponent,
		CheckoutComponent,
		UpdateReceiptComponent,
		ReversereceiptComponent,
		// TranslationAdminComponent, TODO: enable it after deploy to production
		AuthorityConnectionBannerComponent,
		AuthorityToastComponent,
		AppleAppBannerComponent,
		AndroidAppBannerComponent,
		// Invoices V2 Components
		InvoicesV2ListComponent,
		InvoicesV2FormComponent,
		InvoicesV2ProcedurePanelComponent,
		InvoicesV2ViewComponent,
		AiVoiceInvoiceComponent,
		AccountantWelcomeModalComponent,
		 ],
	imports: [
		BreadcrumbModule,
	BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		OverlayModule,
		SharedModule,
		HearingRequestDialogModule,
		AppRoutingModule,
		HttpClientModule,
		NgbModule,
		Ng2SearchPipeModule,
		NgxPaginationModule,
		NgxSpinnerModule,
		 NgSelectModule,
		 AgGridModule,
		 PasswordModule,
		 CalendarModule,
		 DataTableModule,
		 SkeletonModule,
		DropdownModule,
		 OrderListModule,

		 TableModule,      // <-- Import PrimeNG Table
		ButtonModule,     // <-- For buttons
		 InputTextModule,
		MenuModule,
		MultiSelectModule,
		ToastModule,
		ConfirmDialogModule,
		DialogModule,
		ToggleButtonModule,
		CardModule,

		ToastrModule.forRoot(),
		TranslateModule, // Import TranslateModule to make translate pipe available
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			},
			defaultLanguage: 'ar',
			useDefaultLang: true
		}),
		
//     // for HttpClient use:
		LoadingBarHttpClientModule,
//     // for Router use:
		LoadingBarRouterModule,
//     // for Core use:
		LoadingBarModule,
ServiceWorkerModule.register('custom-sw.js', {
	enabled: true,
	// Register the ServiceWorker as soon as the application is stable
	// or after 30 seconds (whichever comes first).
	registrationStrategy: 'registerWhenStable:30000'
}),
		AlldocumentsModule,
		DashboardModule,
		MerchantModule,
		DocumentModule,
		CKEditorModule,
	],
	providers: [ CookieService , 
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpConfigInterceptor,
			
			multi: true,
		},
		DatePipe,
		// TranzilaService,
		NgxSpinnerService,
		MessageService,
		ConfirmationService,
		{
			provide: APP_INITIALIZER,
			useFactory: (translate: TranslateService) => {
				return () => {
					const savedLang = localStorage.getItem('curentLang') || 'ar';
					// Ensure translations are loaded before app starts
					return translate.use(savedLang).toPromise().catch(err => {
						console.error('Failed to load translations:', err);
						// Fallback to default language
						return translate.use('ar').toPromise();
					});
				};
			},
			deps: [TranslateService],
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
